import './FileViewer.scss'
import { ViewerToolBar } from './FileViewerToolBar'
import { Divider } from '@mui/material'
import { FileResource } from '../../item/model/FileResource'

export const PdfViewer = ({ 
    file
}: { 
    file: FileResource
}) => {

    if (!file.uri) {
        return <div>No PDF file URL provided.</div>
    }

    return (
        <div className="viewer-container">
            <ViewerToolBar 
                file={file} 
            />
            <Divider className="divider" />
            <div 
                className="pdf-viewer"
                data-testid="pdf-viewer"
            >
                <div className="pdf-iframe-container">
                    <iframe
                        src={file.uri}
                        className="pdf-iframe"
                        title="PDF Viewer"
                    />
                </div>
            </div>
        </div>
    )
}